import { AbstractViewContribution, FrontendApplicationContribution } from '@theia/core/lib/browser';
import { injectable } from '@theia/core/shared/inversify';
import { PreviewWidget } from './preview';

@injectable()
export class PreviewContribution
    extends AbstractViewContribution<PreviewWidget>
    implements FrontendApplicationContribution
{
    async onDidInitializeLayout(): Promise<void> {
        await this.openView({ activate: false, reveal: true });
    }

    constructor() {
        super({
            widgetId: PreviewWidget.ID,
            widgetName: PreviewWidget.LABEL,
            defaultWidgetOptions: { area: 'right' }
        });
    }
}
